import type { FC } from "react";

import {
  TABS_VARIANT_CLASS_MAP,
  type TTabsLinksProps,
} from "@/ui/components/navigation/Tabs/Tabs.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextControl } from "@/ui/components/typography/TextControl";
import { cn } from "@/ui/lib/utils";

export const TabsLinks: FC<TTabsLinksProps> = ({ links }) => (
  <>
    { links?.map(({ href, icon, label, linkProps }) => (
      <a
        {...linkProps}
        key={href}
        href={href}
        data-component="TabsLink"
        className={cn(
          TABS_VARIANT_CLASS_MAP.icon.links,
          linkProps?.className,
        )}
      >
        <Icon icon={icon} size="lg" aria-hidden="true" />
        <TextControl
          tag="span"
          size={2}
          isResponsive={false}
          color="inherit"
          align="center"
          whitespace="noWrap"
          className={TABS_VARIANT_CLASS_MAP.icon.label}
        >
          { label }
        </TextControl>
      </a>
    )) }
  </>
);

TabsLinks.displayName = "TabsLinks";
